import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';
import { Fragment } from 'react';
import styles from './index.module.scss';

const Designed = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');

    // const [open, setOpen] = useState(false);

    const list = [
        {
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1751273771837/designed_pc1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1751273771269/designed_h51.jpg',
            },
            title: t(`designed_section_title1`),
            desc: t(`designed_section_desc1`),
        },
        {
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1751273772095/designed_pc2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1751273833055/designed_h52.jpg',
            },
            title: t(`designed_section_title2`),
            desc: t(`designed_section_desc2`),
        },
        {
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1751273771626/designed_pc3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1751273772283/designed_h53.jpg',
            },
            title: t(`designed_section_title3`),
            desc: t(`designed_section_desc3`),
        },
    ];

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const sceneJ = AniContainer.create({
    //             triggerElement: '.stream-ultra-x-E',
    //             triggerHook: 1,
    //         });
    //         return () => {
    //             sceneJ.destroy();
    //         };
    //     }
    // }, []);

    // const industryList = [
    //     {
    //         img: 'https://websiteoss.ecoflow.com/upload/image/1751275135429/industry1.jpg',
    //         title: t(`designed_industry_section_title1`),
    //         desc: t(`designed_industry_section_desc1`),
    //     },
    //     {
    //         img: 'https://websiteoss.ecoflow.com/upload/image/1751275135826/industry2.jpg',
    //         title: t(`designed_industry_section_title2`),
    //         desc: t(`designed_industry_section_desc2`),
    //     },
    //     {
    //         img: 'https://websiteoss.ecoflow.com/upload/image/1751275136011/industry3.jpg',
    //         title: t(`designed_industry_section_title3`),
    //         desc: t(`designed_industry_section_desc3`),
    //     },
    // ];

    // const ecoflowList = [
    //     {
    //         title: t('designed_ecoflow_section_title1'),
    //         desc: t(`designed_ecoflow_section_desc1`),
    //     },
    //     {
    //         title: t('designed_ecoflow_section_title2'),
    //         desc: t(`designed_ecoflow_section_desc2`),
    //     },
    // ];

    // const handleClick = () => {
    //     gtm.push({
    //         event: 'uaEvent',
    //         event_name: 'product_details',
    //         tab: t(`designed_title`),
    //         button_name: t(`designed_btn`),
    //     });
    //     setOpen((v) => !v);
    // };

    return (
        <Fragment>
            <div className={`${styles.designed} GtmModuleData-section`} data-section-id={styles.designed} data-section-title={t(`designed_title`)}>
                <div className="content">
                    {/* <div className="text-container">
                        <h2>{t(`designed_title`)}</h2>
                        <p className="intro">{t(`designed_intro`)}</p>
                    </div> */}
                    <div className="list">
                        {list.map((item, index) => {
                            return (
                                <div className="sticky" key={index}>
                                    <div className="text-container">
                                        <h2>{t(`designed_title`)}</h2>
                                        <p className="intro">{t(`designed_intro`)}</p>
                                    </div>
                                    <div className="item">
                                        <EFPicture src={item.img.pc} srcMobile={item.img.h5} alt={item.title} className="img" />
                                        <div className="text-wrapper">
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* <div className={classNames('btn-wrapper', { active: open })} onClick={handleClick}>
                        {t(`designed_btn`)}
                        <EFPicture
                            src="https://websiteoss.ecoflow.com/upload/image/1749633184348/MultiSource-icon.png"
                            alt={t(`multi_source_btn`)}
                            className="icon"
                        />
                    </div> */}
                </div>
            </div>
            {/* <Modal open={open} onClose={() => setOpen(false)}>
                <div className={styles.designedModal}>
                    <div className="text-container">
                        <h2>{t(`designed_industry_title`)}</h2>
                        <p className="intro">{t(`designed_industry_intro`)}</p>
                        <div className="industry-list">
                            {industryList.map((item) => (
                                <div className="item" key={item.title}>
                                    <div className="img-wrapper">
                                        <EFPicture src={item.img} alt={item.title} className="img" />
                                    </div>
                                    <div className="text-wrapper">
                                        <h3>{item.title}</h3>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="text-container ecoflow">
                        <h2>{t(`designed_ecoflow_title`)}</h2>
                        <p className="intro">{t(`designed_ecoflow_intro`)}</p>

                        <div className="content">
                            <EFPicture
                                src="https://websiteoss.ecoflow.com/upload/image/1751275135663/ecoflow-pc.jpg"
                                srcMobile="https://websiteoss.ecoflow.com/upload/image/1751275136278/ecoflow-h5.jpg"
                                alt={t(`designed_ecoflow_title`)}
                                className="img"
                            />
                            <div className="text-wrapper">
                                {ecoflowList.map((item) => (
                                    <div key={item.title} className="item">
                                        <h4>{item.title}</h4>
                                        <p>{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> */}
        </Fragment>
    );
};

export default Designed;
